import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Home from "./Pages/Home";
import ProductDetail from "./Pages/ProductDetail";
import Login from "./Pages/Login";
import Register from "./Pages/Register";
import Forgetpass from "./Pages/Forgetpass";
import ForgetPassEmail from "./Pages/ForgetPassEmail";
import ListProduct from "./Pages/ListProduct";
import Setting from "./Pages/Setting";
import ListAnItem from "./Pages/ListAnItem";
import SettingWishlist from "./components/SettingWishlist";
import SettingNotification from "./components/SettingNotification";
import SettingMemberShip from "./components/SettingMemberShip";
import Settinglost from "./components/Settinglost";
import SettingMybids from "./components/SettingMybids";
import SettingWon from "./components/SettingWon";
import SettingUnsold from "./components/SettingUnsold";
import SettingSold from "./components/SettingSold";
import SettingDraft from "./components/SettingDraft";
import LogOut from "./components/LogOut";
import VerifyPhone from "./Pages/VerifyPhone";
import SettingMySellings from "./components/SettingMySellings";
import ListitemEdit from "./Pages/ListItemEdit";
import SearchProduct from "./Pages/SearchProduct";
import SettingQuestionAnswer from "./components/SettingQuestionAnswer";
import SettingQuesAnswer from "./components/SettingQuesAnswer";
import Test from "./Pages/test";

import PrivateRoute from "./components/PrivateRoute";
import ProductLogin from "./Pages/ProductLogin";
import "./style/css1.css";
import "./style/css2.css";
import "./style/css3.css";
import "./style/css4.css";
import "./style/css5.css";
import "./style/css6.css";
import Memberships from "./Pages/Memberships";
import SellerReview from "./Pages/SellerReview";
import ReviewDetailList from "./components/ReviewDetailList";
import ResetPassword from "./Pages/ResetPassword";
import Bycategory from "./Pages/Bycategory";
import PageNotFound from "./components/PageNotFound";
import OfflinePage from "./components/OfflinePage";
import TermsConditions from "./Pages/TermsConditions";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import HowToSell from "./Pages/HowToSell";
import HowToBid from "./Pages/HowToBid";
import NetworkHandler from "./components/NetworkHandler";
import WeakConnectionWarning from "./components/WeakConnectionWarning";
import RegisterNumber from "./Pages/RegisterNumber";
import ScrollToTop from "./components/ScrollToTop";
import Help from "./Pages/Help";
import CustomerCare from "./Pages/CustomerCare";
import About from "./Pages/About";
import LocationPicker from "./Pages/LocationPicker";
import SettingCharges from "./components/SettingCharges";
import Price from "./Pages/Price";
import SettingChargesDetail from "./components/SettingChargesDetail";
import VerifyEmail from "./Pages/VerifyEmail";
import VerifyOTP from "./Pages/VerifyOTP";
import Faq from "./Pages/Faq";
import Cookies from "js-cookie";
import { useEffect } from "react";
import MembershipSucess from "./Pages/MembershipSucess";
import ChargesPaymentSucess from "./Pages/ChargesPaymentSucess";
function App() {
  // if ("Notification" in window) {
  //   if (Notification.permission !== "granted") {
  //     Notification.requestPermission().then((permission) => {
  //       if (permission === "granted") {
  //         console.log("Notification permission granted.");
  //       } else {
  //         console.log("Notification permission denied.");
  //       }
  //     });
  //   }
  // }



  return (
    // <Router basename="/bsi/auction">
    //  <BrowserRouter basename="/bsi/auction">


    // Redirecion of pages like home page  , auction detail page  , setting page  like that  
    <BrowserRouter basename="/">
      <NetworkHandler />
      <WeakConnectionWarning />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/detail/:id" element={<ProductDetail />} />
        <Route path="/product-list/:id" element={<ListProduct />} />
        <Route path="/search/:id" element={<SearchProduct />} />
        <Route path="/search" element={<SearchProduct />} />
        <Route path="/test" element={<Test />} />
        <Route path="/offline" element={<OfflinePage />} />
        <Route path="/membership" element={<Memberships />} />
        <Route path="/review/:id" element={<SellerReview />} />
        <Route path="/reviewdetail" element={<ReviewDetailList />} />
        <Route path="/list-an-item" element={<ListAnItem />} />
        <Route path="/category/:id" element={<Bycategory />} />
        <Route path="/list-an-item-edit/:id" element={<ListitemEdit />} />
        <Route path="/login" element={<Login />} />
        <Route path="/productlogin" element={<ProductLogin />} />
        <Route path="/log-out" element={<LogOut />} />
        <Route path="/terms-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/register-number" element={<RegisterNumber />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-phone" element={<VerifyPhone />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/payment" element={<Price />} />
        <Route path="/forget-pass" element={<Forgetpass />} />
        <Route path="/forget-pass-email" element={<ForgetPassEmail />} />
        <Route path="/charges_info" element={<HowToSell />} />
        <Route path="/howtobid" element={<HowToBid />} />
        <Route path="/help" element={<Help />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/locationpicker" element={<LocationPicker />} />
        <Route path="/customerCare" element={<CustomerCare />} />
        <Route path="/about-us" element={<About />} />



        <Route path="/membership-payment-success" element={<MembershipSucess />} />
        <Route path="/charges-payment-success" element={<ChargesPaymentSucess />} />




        <Route path="/404" element={<PageNotFound />} />
        <Route path="/" element={<Home />} /> {/* default route */}
        {/* Protected Routes */}
        <Route
          path="/setting"
          element={
            <PrivateRoute>
              <Setting />
            </PrivateRoute>
          }
        />
        <Route
          path="/wishlist"
          element={
            <PrivateRoute>
              <SettingWishlist />
            </PrivateRoute>
          }
        />
        <Route
          path="/mybids"
          element={
            <PrivateRoute>
              <SettingMybids />
            </PrivateRoute>
          }
        />
        <Route
          path="/myselling"
          element={
            <PrivateRoute>
              <SettingMySellings />
            </PrivateRoute>
          }
        />
        <Route
          path="/notification"
          element={
            <PrivateRoute>
              <SettingNotification />
            </PrivateRoute>
          }
        />
        <Route
          path="/question"
          element={
            <PrivateRoute>
              <SettingQuestionAnswer />
            </PrivateRoute>
          }
        />
        <Route
          path="/charges"
          element={
            <PrivateRoute>
              <SettingCharges />
            </PrivateRoute>
          }
        />
        <Route
          path="/charges_detail/:id"
          element={
            <PrivateRoute>
              <SettingChargesDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/answer/:id"
          element={
            <PrivateRoute>
              <SettingQuesAnswer />
            </PrivateRoute>
          }
        />
        <Route
          path="/Subscription"
          element={
            <PrivateRoute>
              <SettingMemberShip />
            </PrivateRoute>
          }
        />
        <Route
          path="/lost"
          element={
            <PrivateRoute>
              <Settinglost />
            </PrivateRoute>
          }
        />
        <Route
          path="/won"
          element={
            <PrivateRoute>
              <SettingWon />
            </PrivateRoute>
          }
        />
        <Route
          path="/unsold"
          element={
            <PrivateRoute>
              <SettingUnsold />
            </PrivateRoute>
          }
        />
        <Route
          path="/sold"
          element={
            <PrivateRoute>
              <SettingSold />
            </PrivateRoute>
          }
        />
        <Route
          path="/drafts"
          element={
            <PrivateRoute>
              <SettingDraft />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
